const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const AT = require("../../core/vault/ActionTypes");
const GenericCopyTable = require("../../core/util/CopyTable");
const CopyTable = require("../../office/data/CopyTable");

const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const {atOfficeStudentData} = require("../../core/vault/StateCursors");

const Avatar = require("../../core/view/Avatar");
const SetCustomerSegment = require("./SetCustomerSegment");
const SetBaLevel = require("./SetBaLevel");
const SetLockScheme = require("./SetLockScheme");
const SetUsername = require("./SetUsername");
const SetPassword = require("./SetPassword");
const RegistrationButton = require("./RegistrationButton").default;
const {computeCustomerSegment} = require("../util/ParentUtil");

const styles = require("./styles/StudentRegistration.css");
const {
	STUDENT_REGISTRATION_EVENTS,
} = require("../../../shared/events/registration");

const secondaryStepList = ["welcome", "customerSegment", "lockScheme", "final"];

const fullStepList = [
	"welcome",
	"customerSegment",
	"baLevel",
	"lockScheme",
	"username",
	"password",
	"final",
];

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => {
		return {
			selectedBaLevel: atOfficeStudentData(vaultState, props.studentID).getIn(
				"grade"
			),
			selectedCustomerSegment: atOfficeStudentData(
				vaultState,
				props.studentID
			).getIn("customerSegment"),
		};
	});
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "StudentRegistration",

		propTypes: {
			studentID: PT.number.isRequired,
			studentData: PT.object.isRequired,
			dispatch: PT.func.isRequired,

			//Injected by HOCs
			selectedBaLevel: PT.number,
			selectedCustomerSegment: PT.string,
		},

		// Used by vault update HOC
		vaultEvents: {
			parentUsernamesGenerationIssue: function({errorType, studentID}) {
				if (studentID === this.props.studentID) {
					const message = GenericCopyTable.forUsernameGenerationError(
						errorType
					);
					this.setErrorMessage(message);
				}
			},
			parentUpdateUnregisteredUserError: function({errorType, studentID}) {
				if (studentID === this.props.studentID) {
					const message = GenericCopyTable.forUpdateUnregisteredUserError(
						errorType
					);
					this.setErrorMessage(message);
				}
			},
		},

		getInitialState: function() {
			return {
				errorMessage: null,
			};
		},

		setErrorMessage: function(message) {
			this.setState({errorMessage: message});
		},

		clearErrorMessage: function() {
			this.setState({errorMessage: null});
		},

		handleStart: function() {
			this.props.dispatch({
				type: AT.PARENT_UPDATE_UNREGISTERED_USER_REQUEST,
				studentID: this.props.studentID,
				start: true,
				event: STUDENT_REGISTRATION_EVENTS.START,
			});
		},

		handleBack: function() {
			this.props.dispatch({
				type: AT.PARENT_UPDATE_UNREGISTERED_USER_REQUEST,
				studentID: this.props.studentID,
				step: "back",
			});
		},

		handleCustomerSegmentSubmit: function(options) {
			if (_.compact(options).length === 3) {
				this.props.dispatch({
					type: AT.PARENT_UPDATE_UNREGISTERED_USER_REQUEST,
					studentID: this.props.studentID,
					settings: {customerSegment: computeCustomerSegment(options)},
					event: STUDENT_REGISTRATION_EVENTS.CUSTOMER_SEGMENT_SUBMIT,
				});
				this.setErrorMessage(null);
			} else {
				this.setErrorMessage(GenericCopyTable.forRegisterNoSegment());
			}
		},

		handleBaLevelSubmit: function(baLevel) {
			if (baLevel) {
				this.props.dispatch({
					type: AT.PARENT_UPDATE_UNREGISTERED_USER_REQUEST,
					studentID: this.props.studentID,
					settings: {grade: baLevel},
					event: STUDENT_REGISTRATION_EVENTS.BA_LEVEL_SUBMIT,
				});
				this.setErrorMessage(null);
			} else {
				this.setErrorMessage(GenericCopyTable.forRegisterNoSettings());
			}
		},

		handleLockSchemeSubmit: function(lockSettings) {
			if (lockSettings && lockSettings.scheme) {
				this.props.dispatch({
					type: AT.PARENT_UPDATE_UNREGISTERED_USER_REQUEST,
					studentID: this.props.studentID,
					settings: {lockSettings},
					event: STUDENT_REGISTRATION_EVENTS.LOCK_SCHEME_SUBMIT,
				});
				this.setErrorMessage(null);
			} else {
				this.setErrorMessage(GenericCopyTable.forRegisterNoSettings());
			}
		},

		handleUsernameSubmit: function(username) {
			if (username) {
				this.props.dispatch({
					type: AT.PARENT_UPDATE_UNREGISTERED_USER_REQUEST,
					studentID: this.props.studentID,
					username,
					event: STUDENT_REGISTRATION_EVENTS.USERNAME_SUBMIT,
				});
				this.setErrorMessage(null);
			} else {
				this.setErrorMessage(GenericCopyTable.forRegisterNoUsername());
			}
		},

		handlePasswordSubmit: function(password, check) {
			if (check.valid) {
				this.props.dispatch({
					type: AT.PARENT_UPDATE_UNREGISTERED_USER_REQUEST,
					studentID: this.props.studentID,
					password,
					event: STUDENT_REGISTRATION_EVENTS.PASSWORD_SUBMIT,
				});
			} else {
				this.setErrorMessage(
					GenericCopyTable.forRegisterPasswordCheckError(
						check.error,
						check.info
					)
				);
			}
		},

		handleRequestRandomUsernames: function() {
			this.props.dispatch({
				type: AT.GET_RANDOM_USERNAMES_FOR_PARENT_REQUEST,
				studentID: this.props.studentID,
			});
		},

		renderFinal: function(Copy, studentData) {
			return (
				<div className={styles.step}>
					{Copy.final.top}
					<div className={styles.finalSpread}>
						<div className={styles.finalInfo}>
							<Avatar
								className={styles.finalAvatar}
								avatar={studentData.avatarData}
								hasRing={true}
								ringSize={3}
							/>
							<div>{studentData.username}</div>
						</div>
						{Copy.final.bottom}
					</div>
				</div>
			);
		},

		renderError: function() {
			return <div className={styles.error}>{this.state.errorMessage}</div>;
		},

		renderButton: function(buttonText, onClick, buttonStyle) {
			// TODO: Just use the button component directly instead of having this function
			return (
				<RegistrationButton
					onClick={onClick}
					buttonText={buttonText}
					isSavingRegistration={this.props.studentData.isSavingRegistration}
					className={buttonStyle}
				/>
			);
		},

		renderStep: function(Copy, step) {
			const {studentData} = this.props;
			const stepList =
				studentData?.primarySetupStep === "FINAL"
					? secondaryStepList
					: fullStepList;
			const stepMap = {
				customerSegment: SetCustomerSegment,
				baLevel: SetBaLevel,
				lockScheme: SetLockScheme,
				username: SetUsername,
				password: SetPassword,
			};
			const Component = stepMap[step];
			const stepCopy = Copy.steps[step];
			const stepActionName = _.camelCase(`handle ${stepCopy.name} submit`);
			let extraProps = {};
			if (step === "lockScheme") {
				extraProps = {baLevel: this.props.selectedBaLevel};
			}
			if (step === "username") {
				extraProps = {
					handleRequestRandomUsernames: this.handleRequestRandomUsernames,
					possibleUsernames: studentData.possibleUsernames,
				};
			}

			// Don't count welcome and final. If they already have a password, don't count that either.
			let extraSteps = 2;
			if (studentData.registrationStatus?.hasSetPassword === true) {
				extraSteps++;
			}

			return (
				<Component
					{...this.props}
					{...extraProps}
					copy={stepCopy}
					renderButton={this.renderButton}
					renderError={this.renderError}
					onChange={this.clearErrorMessage}
					handleSubmit={this[stepActionName]}
					// only show back button if the feature flag is enabled
					handleBack={this.handleBack}
					stepNumber={_.indexOf(stepList, step)}
					totalNumSteps={stepList.length - extraSteps}
				/>
			);
		},

		render: function() {
			const {studentData} = this.props;

			//TODO: Maybe get copy on props change, not every render.
			const Copy = CopyTable.getParentStudentRegistrationCopy(
				studentData,
				styles
			);

			const step = studentData.registrationStep;

			let stepContent, button, below;
			if (step === "welcome") {
				if (studentData?.primarySetupStep === "FINAL") {
					// If they have already finished primary setup, show secondary welcome
					stepContent = Copy.secondaryWelcome.content;
					button = this.renderButton(
						Copy.secondaryWelcome.buttonText,
						this.handleStart
					);
				} else {
					stepContent = Copy.welcome.content;
					button = this.renderButton(
						Copy.welcome.buttonText,
						() =>
							(window.location.href = `/parent/students/setup/${studentData.studentID}`)
					);
					below = null;
				}
			} else if (step === "final") {
				stepContent = this.renderFinal(Copy, studentData);
				button = null; //No button on final
			} else {
				//Let the step handle everything
				return this.renderStep(Copy, step);
			}

			return (
				<div className={styles.main}>
					{stepContent}
					{button}
					{below}
				</div>
			);
		},
	})
);
